import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { catchError, map, Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
import { LoadingService } from 'src/app/tabms/services/loading/loading.service';

@Injectable()
export class BasicAuthInterceptor implements HttpInterceptor {
  constructor(private _loading: LoadingService) { }

  intercept(request: HttpRequest<string>, next: HttpHandler): Observable<HttpEvent<string>> {
    this._loading.setLoading(true, request.url);
    // add auth header with jwt if user is logged in and request is to the api url
    let token = sessionStorage.getItem('access_token');
    let userId;
    let claims = JSON.parse(sessionStorage.getItem('id_token_claims_obj'));
    //  let tenantId
    if (claims) {
      userId = claims['sub'];
      // tenantId = claims?.['tenantid'] || null;
    }
    const isLoggedIn = userId && token;
    const isApiUrl = [environment.apiUrl, environment.apiUrlRE, environment.apiUrlInv, environment.apiUrlHR, environment.apiUrlSS, environment.apiUrlSec].some((url) => request.url.startsWith(url));
    if (isLoggedIn && isApiUrl) {
      // debugger
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
          // 'Abp.TenantId': tenantId

        }
      });
    }

    return next
      .handle(request)
      .pipe(
        catchError((err) => {
          this._loading.setLoading(false, request.url);
          return err;
        })
      )
      .pipe(
        map<HttpEvent<any>, any>((evt: HttpEvent<any>) => {
          if (evt instanceof HttpResponse) {
            this._loading.setLoading(false, request.url);
          }
          return evt;
        })
      );
  }
}
